<template>
  <ga-button-icon-only
    :class="b(mods)"
    :size="buttonSize"
    icon-size="l"
    round
    view="tint"
    :loading="loading"
    @click="$emit('click')"
  >
    <template #icon>
      <ga-icon-additional-cart-add />
    </template>
  </ga-button-icon-only>
</template>

<script src="./cart-button.scripts.js" />

<style module src="./cart-button.styles.scss" lang="scss" />
